// extracted by mini-css-extract-plugin
export default {"root":"Pagetop_root__r0+NR","pageTop":"Pagetop_pageTop__vUkw9","polygon":"Pagetop_polygon__aMmvq"};